<script setup lang="ts">
const { vacancy } = defineProps<{
  /**
   * The vacancy to apply for.
   */
  vacancy: Vacancy
  /***
   *
   */
  application: ActivityApplication
}>()

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <BaseHeading>
    {{ t('thanksMessage', { firstName: application.firstName }) }}
  </BaseHeading>
  <BaseParagraph>
    {{
      t('responseSoonMessage', {
        contactPersonFirstName: vacancy.contactPersonFirstName,
      })
    }}
  </BaseParagraph>
</template>

<i18n lang="json">
{
  "en": {
    "thanksMessage": "Thanks for applying, {firstName}!",
    "responseSoonMessage": "{contactPersonFirstName} will respond to your application soon."
  },
  "nl": {
    "thanksMessage": "Bedankt voor je aanmelding, {firstName}!",
    "responseSoonMessage": "{contactPersonFirstName} geeft zo snel mogelijk een reactie op je aanmelding."
  }
}
</i18n>
